import { render, staticRenderFns } from "./liveViewStatistics.vue?vue&type=template&id=654c40f6"
import script from "./liveViewStatistics.vue?vue&type=script&lang=js"
export * from "./liveViewStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports